<template>
  <div class="topicManage" v-loading="loading">
    <div class="breadcrumb">话题管理</div>

    <div class="search">
      <el-form
        :inline="true"
        :model="queryParam"
        label-width="72px"
        class="search-row"
      >
        <el-form-item label="话题ID">
          <el-input
            v-model.trim="queryParam.topicId"
            placeholder="精确搜索"
            clearable
            style="width: 150px"
            @keyup.enter.native="clickSearch"
          >
          </el-input>
        </el-form-item>
        <el-form-item label="用户ID">
          <el-input
            v-model.trim="queryParam.createdUid"
            placeholder="模糊搜索"
            clearable
            style="width: 150px"
            @keyup.enter.native="clickSearch"
          >
          </el-input>
        </el-form-item>
        <el-form-item label="话题名称">
          <el-input
            v-model.trim="queryParam.topicName"
            placeholder="模糊搜索"
            clearable
            style="width: 160px"
            @keyup.enter.native="clickSearch"
          >
          </el-input>
        </el-form-item>
        <el-form-item label="话题类别">
          <el-select v-model="queryParam.categoryId" style="width: 120px">
            <el-option label="全部" :value="0"></el-option>
            <el-option
              v-for="item in categories"
              :key="item.value"
              :label="item.label"
              :value="item.value"
            >
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="创建时间">
          <el-date-picker
            v-model="queryParam.beginCreatedAtMs"
            type="datetime"
            placeholder="时间选择器"
            style="width: 190px"
          >
          </el-date-picker>
          <span class="range-divider">~</span>
          <el-date-picker
            v-model="queryParam.endCreatedAtMs"
            type="datetime"
            placeholder="时间段"
            style="width: 190px"
          >
          </el-date-picker>
        </el-form-item>
        <el-form-item label="是否精选">
          <el-select v-model="queryParam.isEssence" style="width: 120px">
            <el-option label="全部" :value="-1"></el-option>
            <el-option label="是" :value="1"></el-option>
            <el-option label="否" :value="0"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="是否置顶">
          <el-select v-model="queryParam.isSticky" style="width: 120px">
            <el-option label="全部" :value="-1"></el-option>
            <el-option label="是" :value="1"></el-option>
            <el-option label="否" :value="0"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="状态">
          <el-select v-model="queryParam.status" style="width: 120px">
            <el-option label="全部" :value="0"></el-option>
            <el-option label="已发布" :value="2"></el-option>
            <el-option label="已停用" :value="1"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item class="search-action-item">
          <el-button @click="clickReset">重置</el-button>
          <el-button type="primary" @click="clickSearch">查询</el-button>
        </el-form-item>
      </el-form>
    </div>

    <div class="toolbar">
      <el-button type="primary" @click="goNewTopic">新建话题</el-button>
    </div>

    <el-dialog
      :title="createTopicForm.id > 0 ? '编辑话题' : '新增话题'"
      v-model="createTopicDialogVisible"
      custom-class="topic-create-drawer"
      top="0"
      :modal-append-to-body="false"
      :close-on-click-modal="false"
      @close="handleCreateDialogClose"
    >
      <div class="topic-create-content">
        <el-form
          ref="createTopicForm"
          :model="createTopicForm"
          :rules="createTopicRules"
          label-width="92px"
        >
          <el-form-item label="话题头像" prop="coverImage">
            <SUpload
              :value="[createTopicForm.coverImage]"
              accept="image/*"
              type="drag"
              :size="50"
              :show-file-list="false"
              :on-success="handleCoverUploadSuccess"
            />
            <div class="supload-tips">
              建议尺寸73*73，大小≤50KB，优先webp次选png
            </div>
          </el-form-item>
          <el-form-item label="详情页图片" prop="detailImage">
            <SUpload
              :value="[createTopicForm.detailImage]"
              accept="image/*"
              type="drag"
              :size="50"
              :show-file-list="false"
              :on-success="handleDetailUploadSuccess"
            />
            <div class="supload-tips">
              建议尺寸375*184，大小≤50KB，优先webp次选png
            </div>
          </el-form-item>
          <el-form-item label="话题名称" prop="title">
            <el-input
              v-model.trim="createTopicForm.title"
              maxlength="50"
              placeholder="话题名称"
              :disabled="createTopicForm.id > 0"
            ></el-input>
          </el-form-item>
          <el-form-item label="摘要" prop="summary">
            <el-input
              v-model.trim="createTopicForm.summary"
              type="textarea"
              :autosize="{ minRows: 3, maxRows: 6 }"
              :maxlength="500"
              placeholder="不超过500个字符"
            >
            </el-input>
          </el-form-item>
          <el-form-item label="类别" prop="categoryId">
            <el-select
              v-model="createTopicForm.categoryId"
              placeholder="请选择"
              style="width: 180px"
            >
              <el-option
                v-for="item in categories"
                :key="item.value"
                :label="item.label"
                :value="item.value"
              >
              </el-option>
            </el-select>
          </el-form-item>
          <select-school
            :schObj="createTopicForm.schObj"
            @changeVal="handleSchoolChange"
          ></select-school>
        </el-form>
      </div>
      <div slot="footer" class="topic-create-footer">
        <el-button @click="createTopicDialogVisible = false">取消</el-button>
        <el-button type="primary" @click="submitCreateTopic">确定</el-button>
      </div>
    </el-dialog>

    <div class="com-list">
      <el-table
        :data="listData"
        border
        @selection-change="handleSelectionChange"
        @sort-change="handleSortChange"
      >
        <el-table-column
          type="selection"
          width="50"
          align="center"
        ></el-table-column>
        <el-table-column
          prop="id"
          label="话题ID"
          min-width="90"
          align="center"
        ></el-table-column>
        <el-table-column label="封面图片" min-width="100" align="center">
          <template scope="{ row }">
            <img
              v-if="row.coverImage"
              :src="row.coverImage"
              class="thumb-img thumb-img-clickable"
              alt=""
              @click="openImagePreview(row.coverImage, '话题图片')"
            />
            <span v-else>--</span>
          </template>
        </el-table-column>
        <el-table-column label="详情页图片" min-width="140" align="center">
          <template scope="{ row }">
            <img
              v-if="row.detailImage"
              :src="row.detailImage"
              class="thumb-img thumb-img-clickable"
              alt=""
              @click="openImagePreview(row.detailImage, '详情页图片')"
            />
            <span v-else>--</span>
          </template>
        </el-table-column>
        <el-table-column
          prop="title"
          label="话题名称"
          min-width="180"
          align="center"
          show-overflow-tooltip
        ></el-table-column>
        <el-table-column
          prop="category"
          label="类别"
          min-width="90"
          align="center"
        ></el-table-column>
        <el-table-column
          prop="createTimeText"
          label="创建时间"
          min-width="170"
          align="center"
        ></el-table-column>
        <el-table-column
          prop="createrText"
          label="创建人"
          min-width="95"
          align="center"
        ></el-table-column>
        <el-table-column
          prop="participateUserCount"
          label="发帖人数"
          min-width="140"
          align="center"
        >
        </el-table-column>
        <el-table-column
          prop="postCount"
          label="发帖次数"
          min-width="140"
          align="center"
          sortable="custom"
        >
        </el-table-column>
        <el-table-column
          prop="detailViewCount"
          label="详情页浏览次数"
          min-width="165"
          align="center"
          sortable="custom"
        >
        </el-table-column>
        <el-table-column
          prop="isEssenceText"
          label="是否精选"
          min-width="100"
          align="center"
        ></el-table-column>
        <el-table-column label="是否置顶" min-width="190" align="center">
          <template scope="{ row }">
            <div v-if="row.isSticky === 1" class="pin-time-cell">
              <div>是</div>
              <div class="pin-time-line">
                {{ row.stickyStartAtText || "--" }}
              </div>
              <div v-if="row.stickyEndAtText" class="pin-time-line">
                至 {{ row.stickyEndAtText }}
              </div>
            </div>
            <span v-else>否</span>
          </template>
        </el-table-column>
        <el-table-column
          prop="statusText"
          label="状态"
          min-width="80"
          align="center"
        ></el-table-column>
        <el-table-column
          label="操作"
          min-width="280"
          align="center"
          fixed="right"
        >
          <template scope="{ row }">
            <el-button type="text" @click="openEditTopic(row)">编辑</el-button>
            <el-button type="text" @click="toggleRowStatus(row)">
              {{ Number(row.status) === 2 ? "停用" : "启用" }}
            </el-button>
            <el-button type="text" @click="toggleRowEssence(row)">
              {{ Number(row.isEssence) === 1 ? "取消精选" : "精选" }}
            </el-button>
            <el-button type="text" @click="openPinDialog(row)">
              {{ Number(row.isSticky) === 1 ? "取消置顶" : "置顶" }}
            </el-button>
          </template>
        </el-table-column>
      </el-table>
    </div>

    <div class="pagination-wrapper">
      <div class="bottom-action-wrapper">
        <el-button
          type="primary"
          :disabled="selectedRows.length === 0"
          @click="openBatchEssenceDialog"
          >精选</el-button
        >
        <el-button
          type="primary"
          :disabled="selectedRows.length === 0"
          @click="openBatchStatusDialog"
          >修改状态</el-button
        >
      </div>
      <el-pagination
        v-show="total > 0"
        class="topic-pagination"
        layout="total, prev, pager, next, jumper"
        :page-size="queryParam.pageSize"
        :current-page="queryParam.pageNum"
        :total="total"
        @current-change="handlePageChange"
      >
      </el-pagination>
    </div>

    <el-dialog
      title="精选"
      size="tiny"
      :modal-append-to-body="false"
      v-model="batchEssenceDialog.visible"
    >
      <el-form label-width="90px">
        <el-form-item label="是否精选">
          <el-select
            v-model="batchEssenceDialog.isEssence"
            style="width: 220px"
          >
            <el-option label="是" :value="1"></el-option>
            <el-option label="否" :value="0"></el-option>
          </el-select>
        </el-form-item>
      </el-form>
      <div slot="footer">
        <el-button @click="batchEssenceDialog.visible = false">取消</el-button>
        <el-button type="primary" @click="submitBatchEssence">确定</el-button>
      </div>
    </el-dialog>

    <el-dialog
      title="修改状态"
      size="tiny"
      :modal-append-to-body="false"
      v-model="batchStatusDialog.visible"
    >
      <el-form label-width="90px">
        <el-form-item label="状态">
          <el-select v-model="batchStatusDialog.status" style="width: 220px">
            <el-option label="启用" :value="2"></el-option>
            <el-option label="停用" :value="1"></el-option>
          </el-select>
        </el-form-item>
      </el-form>
      <div slot="footer">
        <el-button @click="batchStatusDialog.visible = false">取消</el-button>
        <el-button type="primary" @click="submitBatchStatus">确定</el-button>
      </div>
    </el-dialog>

    <el-dialog
      title="置顶"
      :modal-append-to-body="false"
      v-model="pinDialog.visible"
    >
      <el-form label-width="90px">
        <el-form-item label="是否置顶">
          <el-select v-model="pinDialog.isSticky" style="width: 220px">
            <el-option label="是" :value="1"></el-option>
            <el-option label="否" :value="0"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item v-if="pinDialog.isSticky === 1" label="置顶时间">
          <el-date-picker
            v-model="pinDialog.stickyTime"
            type="datetimerange"
            range-separator="至"
            placeholder="请选择开始时间至结束时间"
            style="width: 380px"
          ></el-date-picker>
          <div class="dialog-tip">置顶后，该话题将在APP推荐页的第一个坑位</div>
        </el-form-item>
      </el-form>
      <div slot="footer">
        <el-button @click="pinDialog.visible = false">取消</el-button>
        <el-button type="primary" :loading="pinSubmitting" @click="submitPin"
          >确认</el-button
        >
      </div>
    </el-dialog>

    <el-dialog
      :title="imagePreview.title"
      size="large"
      :modal-append-to-body="false"
      custom-class="topic-image-preview-dialog"
      v-model="imagePreview.visible"
      @close="closeImagePreview"
    >
      <div class="image-preview-body">
        <img
          v-if="imagePreview.url"
          :src="imagePreview.url"
          class="image-preview-img"
          alt=""
        />
      </div>
      <div slot="footer">
        <el-button @click="closeImagePreview">关闭</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import selectSchool from "../../common/selectSch.vue";

const LOG_TAG_TOPIC_MANAGE = "[TopicManage]";

export default {
  components: {
    selectSchool,
  },
  data() {
    return {
      loading: false,
      categories: [],
      queryParam: this.getDefaultQueryParam(),
      /** 列表总条数（接口 totalCount / total） */
      total: 0,
      listData: [],
      selectedRows: [],
      createTopicDialogVisible: false,
      createTopicForm: this.getDefaultCreateTopicForm(),
      createTopicRules: {
        coverImage: [
          { required: true, message: "请上传话题头像", trigger: "change" },
        ],
        title: [
          { required: true, message: "请输入话题名称", trigger: "blur" },
          { min: 1, max: 50, message: "不超过50个字符", trigger: "blur" },
        ],
        summary: [
          { required: true, message: "请输入摘要", trigger: "blur" },
          { min: 1, max: 500, message: "不超过500个字符", trigger: "blur" },
        ],
        categoryId: [
          {
            required: true,
            trigger: "change",
            validator: (rule, value, callback) => {
              if (value === "" || value === null || value === undefined) {
                callback(new Error("请选择类别"));
              } else {
                callback();
              }
            },
          },
        ],
      },
      batchEssenceDialog: {
        visible: false,
        isEssence: 1,
      },
      batchStatusDialog: {
        visible: false,
        status: 2,
      },
      pinDialog: {
        visible: false,
        topicId: null,
        isSticky: 1,
        stickyTime: "",
      },
      pinSubmitting: false,
      imagePreview: {
        visible: false,
        url: "",
        title: "查看图片",
      },
    };
  },
  mounted() {
    this.getClasses();
    this.queryList();
  },
  methods: {
    getDefaultQueryParam() {
      return {
        topicId: "",
        createdUid: "",
        topicName: "",
        categoryId: 0,
        beginCreatedAtMs: "",
        endCreatedAtMs: "",
        isEssence: -1,
        isSticky: -1,
        status: 0,
        sortField: 0,
        sortOrder: "desc",
        pageNum: 1,
        pageSize: 20,
      };
    },
    getDefaultCreateTopicForm() {
      return {
        id: 0,
        coverImage: "",
        detailImage: "",
        title: "",
        summary: "",
        categoryId: "",
        schObj: {
          applicableCampus: "0",
          shieldedSchools: [],
          openedSchools: [],
        },
      };
    },
    isRequestSuccess(errorCode) {
      return errorCode === 10000 || errorCode === 0;
    },
    handleSchoolChange(schObj) {
      this.createTopicForm.schObj = schObj;
    },
    handleCoverUploadSuccess(response) {
      if (!this.isRequestSuccess(response && response.error)) {
        this.$message.error((response && response.message) || "上传失败");
        return;
      }
      this.createTopicForm.coverImage = response.data || "";
    },
    handleDetailUploadSuccess(response) {
      if (!this.isRequestSuccess(response && response.error)) {
        this.$message.error((response && response.message) || "上传失败");
        return;
      }
      this.createTopicForm.detailImage = response.data || "";
    },
    handleCreateDialogClose() {
      this.resetCreateTopicForm();
    },
    resetCreateTopicForm() {
      this.createTopicForm = this.getDefaultCreateTopicForm();
      if (this.$refs.createTopicForm) {
        this.$refs.createTopicForm.clearValidate();
      }
    },
    buildCreateTopicRootUnids() {
      const schObj = this.createTopicForm.schObj;
      if (schObj.applicableCampus === "1") {
        return schObj.openedSchools
          .map((item) => Number(item.rootUnid))
          .filter((item) => item > 0);
      }
      return schObj.shieldedSchools
        .map((item) => Number(item.rootUnid))
        .filter((item) => item > 0);
    },
    submitCreateTopic() {
      if (
        this.createTopicForm.schObj.applicableCampus === "1" &&
        this.createTopicForm.schObj.openedSchools.length === 0
      ) {
        this.$message.warning("请添加应用学校");
        return;
      }
      this.$refs.createTopicForm.validate((valid) => {
        if (!valid) {
          return;
        }
        const body = {
          id: Number(this.createTopicForm.id) || 0,
          categoryId: Number(this.createTopicForm.categoryId),
          title: this.createTopicForm.title,
          coverImage: this.createTopicForm.coverImage,
          detailImage: this.createTopicForm.detailImage,
          summary: this.createTopicForm.summary,
          topicStatus: 2,
          publishNum: 0,
          applicableCampus: Number(
            this.createTopicForm.schObj.applicableCampus
          ),
          rootUnids: this.buildCreateTopicRootUnids(),
          initParticipateNum: "",
          initialNum: 0,
        };
        this.loading = true;
        this.$http({
          method: "POST",
          url: this.$util.domain + "/adminapi/v2/operate/topic/add",
          body: JSON.stringify(body),
        })
          .then((res) => {
            const result = (res && (res.body || res.data)) || {};
            if (!this.isRequestSuccess(result.error)) {
              this.$message.error(result.message || "新增失败");
              return;
            }
            this.$message.success(body.id > 0 ? "编辑成功" : "新增成功");
            this.createTopicDialogVisible = false;
            this.queryList();
          })
          .catch((err) => {
            console.error(LOG_TAG_TOPIC_MANAGE, "submitCreateTopic error", err);
            this.$message.error(body.id > 0 ? "编辑失败" : "新增失败");
          })
          .finally(() => {
            this.loading = false;
          });
      });
    },
    getClasses() {
      this.$http({
        method: "POST",
        url: this.$util.domain + "/adminapi/v2/operate/topic/categories",
      })
        .then((res) => {
          const result = (res && (res.body || res.data)) || {};
          if (!this.isRequestSuccess(result.error)) {
            this.$message.error(result.message || "获取类别失败");
            return;
          }
          const list = result.data || [];
          this.categories = list.map((item) => ({
            label: item.name,
            value: Number(item.id) || 0,
          }));
        })
        .catch((err) => {
          console.error(LOG_TAG_TOPIC_MANAGE, "getClasses error", err);
          this.$message.error("获取类别失败");
        });
    },
    formatDateTime(value) {
      if (!value) {
        return "--";
      }
      const date = new Date(value);
      if (isNaN(date.getTime())) {
        return "--";
      }
      const yyyy = date.getFullYear();
      const MM = String(date.getMonth() + 1).padStart(2, "0");
      const dd = String(date.getDate()).padStart(2, "0");
      const hh = String(date.getHours()).padStart(2, "0");
      const mm = String(date.getMinutes()).padStart(2, "0");
      const ss = String(date.getSeconds()).padStart(2, "0");
      return `${yyyy}/${MM}/${dd} ${hh}:${mm}:${ss}`;
    },
    resolveStatusText(status) {
      const map = {
        1: "已停用",
        2: "已发布",
      };
      return map[Number(status)] || "--";
    },
    buildQueryBody() {
      const body = {
        categoryId: Number(this.queryParam.categoryId) || 0,
        isEssence: Number(this.queryParam.isEssence),
        isSticky: Number(this.queryParam.isSticky),
        status: Number(this.queryParam.status) || 0,
      };
      // 排序：sortField 0=创建时间(默认) 1=发帖次数 2=详情页浏览次数；0 时不传，走后端默认
      const sortField = Number(this.queryParam.sortField) || 0;
      if (sortField > 0) {
        body.sortField = sortField;
        body.sortOrder = this.queryParam.sortOrder === "asc" ? "asc" : "desc";
      }
      const topicId = String(this.queryParam.topicId || "").trim();
      if (topicId !== "") {
        body.topicId = Number(topicId);
      }
      const createdUid = String(this.queryParam.createdUid || "").trim();
      if (createdUid !== "") {
        body.createdUid = Number(createdUid);
      }
      const topicName = String(this.queryParam.topicName || "").trim();
      if (topicName !== "") {
        body.topicName = topicName;
      }
      if (this.queryParam.beginCreatedAtMs) {
        body.beginCreatedAtMs = new Date(
          this.queryParam.beginCreatedAtMs
        ).getTime();
      }
      if (this.queryParam.endCreatedAtMs) {
        body.endCreatedAtMs = new Date(
          this.queryParam.endCreatedAtMs
        ).getTime();
      }
      const pageNum = Number(this.queryParam.pageNum) || 1;
      const pageSize = Number(this.queryParam.pageSize) || 20;
      body.pageNum = pageNum;
      body.pageSize = pageSize;
      return body;
    },
    formatListItem(item) {
      const participateUserCount = item.participateUserCount;
      const postCount = item.postCount;
      const detailViewCount = item.detailViewCount;
      return {
        ...item,
        createTimeText: this.formatDateTime(item.createTime),
        createrText: item.creater || "--",
        participateUserCount:
          participateUserCount === null || participateUserCount === undefined
            ? "--"
            : participateUserCount,
        postCount:
          postCount === null || postCount === undefined ? "--" : postCount,
        detailViewCount:
          detailViewCount === null || detailViewCount === undefined
            ? "--"
            : detailViewCount,
        isEssenceText: Number(item.isEssence) === 1 ? "是" : "否",
        isSticky: Number(item.isSticky) === 1 ? 1 : 0,
        // 置顶时间是毫秒时间戳
        stickyStartAtText: item.stickyStartAt
          ? this.formatDateTime(Number(item.stickyStartAt))
          : "",
        stickyEndAtText: item.stickyEndAt
          ? this.formatDateTime(Number(item.stickyEndAt))
          : "",
        statusText: this.resolveStatusText(item.status),
      };
    },
    queryList() {
      this.loading = true;
      this.$http({
        method: "POST",
        url: this.$util.domain + "/adminapi/v2/operate/topic/query",
        body: JSON.stringify(this.buildQueryBody()),
      })
        .then((res) => {
          const result = (res && (res.body || res.data)) || {};
          if (!this.isRequestSuccess(result.error)) {
            this.$message.error(result.message || "查询失败");
            this.listData = [];
            this.selectedRows = [];
            this.total = 0;
            return;
          }
          const data = result.data || {};
          const list = data.list || [];
          this.listData = list.map((item) => this.formatListItem(item));
          this.selectedRows = [];
          const tc = data.totalCount != null ? data.totalCount : data.total;
          this.total = Number(tc) >= 0 ? Number(tc) : list.length;
        })
        .catch((err) => {
          console.error(LOG_TAG_TOPIC_MANAGE, "queryList error", err);
          this.$message.error("查询失败");
          this.listData = [];
          this.selectedRows = [];
          this.total = 0;
        })
        .finally(() => {
          this.loading = false;
        });
    },
    /**
     * 列表排序：V2TopicQueryReqModel 用 sortField + sortOrder
     * sortField：0 创建时间(默认) / 1 发帖次数 / 2 详情页浏览次数
     */
    handleSortChange({ prop, order }) {
      const propToField = {
        // 发帖人数：后端 sortField 文档暂未列出，暂用 3（待后端确认）
        participateUserCount: 3,
        postCount: 1,
        detailViewCount: 2,
      };
      if (!prop || !order || !propToField[prop]) {
        this.queryParam.sortField = 0;
        this.queryParam.sortOrder = "desc";
      } else {
        this.queryParam.sortField = propToField[prop];
        this.queryParam.sortOrder = order === "ascending" ? "asc" : "desc";
      }
      this.queryParam.pageNum = 1;
      this.queryList();
    },
    /** 打开置顶弹窗：与精选一致，默认取当前状态的相反值（已置顶→取消置顶） */
    openPinDialog(row) {
      if (!row || !row.id) {
        return;
      }
      const sticky = Number(row.isSticky) === 1;
      this.pinDialog.topicId = row.id;
      this.pinDialog.isSticky = sticky ? 0 : 1;
      this.pinDialog.stickyTime = "";
      if (sticky && row.stickyStartAt && row.stickyEndAt) {
        const start = new Date(Number(row.stickyStartAt));
        const end = new Date(Number(row.stickyEndAt));
        if (!isNaN(start.getTime()) && !isNaN(end.getTime())) {
          this.pinDialog.stickyTime = [start, end];
        }
      }
      this.pinDialog.visible = true;
    },
    /** 话题置顶/取消置顶：POST /adminapi/v2/operate/topic/change_sticky */
    submitPin() {
      const topicId = this.pinDialog.topicId;
      if (!topicId) {
        this.$message.warning("话题信息缺失");
        return;
      }
      const isSticky = Number(this.pinDialog.isSticky);
      const body = {
        topicId: Number(topicId),
        isSticky,
      };
      if (isSticky === 1) {
        const range = this.pinDialog.stickyTime;
        if (!Array.isArray(range) || !range[0] || !range[1]) {
          this.$message.warning("请选择置顶时间");
          return;
        }
        const startMs = new Date(range[0]).getTime();
        const endMs = new Date(range[1]).getTime();
        if (isNaN(startMs) || isNaN(endMs)) {
          this.$message.warning("置顶时间格式不正确");
          return;
        }
        if (endMs <= startMs) {
          this.$message.warning("置顶结束时间需晚于开始时间");
          return;
        }
        // 接口要求毫秒时间戳
        body.stickyStartAt = startMs;
        body.stickyEndAt = endMs;
      }
      this.pinSubmitting = true;
      this.$http({
        method: "POST",
        url: this.$util.domain + "/adminapi/v2/operate/topic/change_sticky",
        body: JSON.stringify(body),
      })
        .then((res) => {
          const result = (res && (res.body || res.data)) || {};
          if (this.isRequestSuccess(result.error)) {
            this.$message.success("操作成功");
            this.pinDialog.visible = false;
            this.queryList();
            return;
          }
          this.$message.error(result.message || "操作失败");
        })
        .catch((err) => {
          console.error(LOG_TAG_TOPIC_MANAGE, "submitPin error", err);
          this.$message.error("操作失败");
        })
        .finally(() => {
          this.pinSubmitting = false;
        });
    },
    handleSelectionChange(rows) {
      this.selectedRows = rows || [];
    },
    validateSearchCondition() {
      const topicId = String(this.queryParam.topicId || "").trim();
      if (topicId && (!/^\d+$/.test(topicId) || Number(topicId) <= 0)) {
        this.$message.warning("话题ID需为正整数");
        return false;
      }
      const createdUid = String(this.queryParam.createdUid || "").trim();
      if (createdUid && !/^\d+$/.test(createdUid)) {
        this.$message.warning("用户ID仅支持数字");
        return false;
      }
      if (this.queryParam.beginCreatedAtMs && this.queryParam.endCreatedAtMs) {
        const begin = new Date(this.queryParam.beginCreatedAtMs).getTime();
        const end = new Date(this.queryParam.endCreatedAtMs).getTime();
        if (begin > end) {
          this.$message.warning("创建开始时间不能大于结束时间");
          return false;
        }
      }
      return true;
    },
    clickSearch() {
      if (!this.validateSearchCondition()) {
        return;
      }
      this.queryParam.pageNum = 1;
      this.queryList();
    },
    handlePageChange(page) {
      const p = Number(page) || 1;
      if (p === this.queryParam.pageNum) {
        return;
      }
      this.queryParam.pageNum = p;
      this.queryList();
    },
    clickReset() {
      this.queryParam = this.getDefaultQueryParam();
      this.selectedRows = [];
      this.queryList();
    },
    getSelectedTopicIds() {
      return this.selectedRows.map((item) => item.id).filter(Boolean);
    },
    submitStatus(topicIds, newStatus) {
      if (!topicIds.length) {
        this.$message.warning("请先选择话题");
        return Promise.reject(new Error("empty ids"));
      }
      this.loading = true;
      return this.$http({
        method: "POST",
        url: this.$util.domain + "/adminapi/v2/operate/topic/change_status",
        body: JSON.stringify({
          topicIds,
          newStatus,
        }),
      })
        .then((res) => {
          const result = (res && (res.body || res.data)) || {};
          if (!this.isRequestSuccess(result.error)) {
            this.$message.error(result.message || "操作失败");
            return false;
          }
          this.$message.success("操作成功");
          this.queryList();
          return true;
        })
        .catch((err) => {
          console.error(LOG_TAG_TOPIC_MANAGE, "submitStatus error", err);
          this.$message.error("操作失败");
          return false;
        })
        .finally(() => {
          this.loading = false;
        });
    },
    submitEssence(topicIds, nextEssence) {
      if (!topicIds.length) {
        this.$message.warning("请先选择话题");
        return Promise.reject(new Error("empty ids"));
      }
      const newStatus = Number(nextEssence) === 1 ? 2 : 1;
      this.loading = true;
      return this.$http({
        method: "POST",
        url: this.$util.domain + "/adminapi/v2/operate/topic/change_essence",
        body: JSON.stringify({
          topicIds,
          newStatus,
        }),
      })
        .then((res) => {
          const result = (res && (res.body || res.data)) || {};
          if (!this.isRequestSuccess(result.error)) {
            this.$message.error(result.message || "操作失败");
            return false;
          }
          this.$message.success("操作成功");
          this.queryList();
          return true;
        })
        .catch((err) => {
          console.error(LOG_TAG_TOPIC_MANAGE, "submitEssence error", err);
          this.$message.error("操作失败");
          return false;
        })
        .finally(() => {
          this.loading = false;
        });
    },
    toggleRowStatus(row) {
      const nextStatus = Number(row.status) === 2 ? 1 : 2;
      this.submitStatus([row.id], nextStatus);
    },
    toggleRowEssence(row) {
      const nextEssence = Number(row.isEssence) === 1 ? 0 : 1;
      this.submitEssence([row.id], nextEssence);
    },
    openBatchEssenceDialog() {
      if (!this.selectedRows.length) {
        this.$message.warning("请先选择话题");
        return;
      }
      this.batchEssenceDialog.isEssence = 1;
      this.batchEssenceDialog.visible = true;
    },
    openBatchStatusDialog() {
      if (!this.selectedRows.length) {
        this.$message.warning("请先选择话题");
        return;
      }
      this.batchStatusDialog.status = 2;
      this.batchStatusDialog.visible = true;
    },
    submitBatchEssence() {
      const topicIds = this.getSelectedTopicIds();
      this.submitEssence(topicIds, this.batchEssenceDialog.isEssence)
        .then((ok) => {
          if (ok) {
            this.batchEssenceDialog.visible = false;
          }
        })
        .catch(() => {});
    },
    submitBatchStatus() {
      const topicIds = this.getSelectedTopicIds();
      this.submitStatus(topicIds, this.batchStatusDialog.status)
        .then((ok) => {
          if (ok) {
            this.batchStatusDialog.visible = false;
          }
        })
        .catch(() => {});
    },
    openImagePreview(url, title) {
      if (!url) {
        return;
      }
      this.imagePreview.url = url;
      this.imagePreview.title = title || "查看图片";
      this.imagePreview.visible = true;
    },
    closeImagePreview() {
      this.imagePreview.visible = false;
      this.imagePreview.url = "";
      this.imagePreview.title = "查看图片";
    },
    openEditTopic(row) {
      this.createTopicDialogVisible = true;
      this.$nextTick(() => {
        const applicableCampus = String(
          row.applicableCampus != null ? row.applicableCampus : "0"
        );
        // 优先使用 campusList（含 name），兼容 rootUnids（纯 id 数组）
        let schoolList = [];
        if (Array.isArray(row.campusList) && row.campusList.length > 0) {
          schoolList = row.campusList.map((item) => ({
            rootUnid: item.rootUnid,
            name: item.name || "",
          }));
        } else if (Array.isArray(row.rootUnids) && row.rootUnids.length > 0) {
          schoolList = row.rootUnids.map((uid) => ({ rootUnid: uid }));
        }
        this.createTopicForm = {
          id: Number(row.id) || 0,
          coverImage: row.coverImage || "",
          detailImage: row.detailImage || "",
          title: row.title || "",
          summary: row.summary || "",
          categoryId: row.categoryId != null ? Number(row.categoryId) : "",
          schObj: {
            applicableCampus,
            shieldedSchools: applicableCampus === "1" ? [] : schoolList,
            openedSchools: applicableCampus === "1" ? schoolList : [],
          },
        };
        this.$nextTick(() => {
          if (this.$refs.createTopicForm) {
            this.$refs.createTopicForm.clearValidate();
          }
        });
      });
    },
    goNewTopic() {
      location.href = "/#/yunying/topic/newTopic";
    },
  },
};
</script>

<style scoped>
.topicManage .search {
  margin: 16px 0 8px;
}

.search-row {
  margin-bottom: 0;
}

.search-action-item {
  margin-left: 36px;
}

.range-divider {
  display: inline-block;
  margin: 0 8px;
}

.toolbar {
  padding: 8px 20px 12px;
}

.topicManage >>> .topic-create-drawer {
  width: 460px;
  max-width: 92vw;
  margin: 0 0 0 auto !important;
  height: 100vh;
  position: absolute;
  right: 0;
  top: 0;
  transform: none;
}

.topicManage >>> .topic-create-drawer .el-dialog__header {
  padding: 20px 20px 10px;
}

.topicManage >>> .topic-create-drawer .el-dialog__body {
  padding: 10px 20px 0;
  height: calc(100vh - 112px);
  overflow-y: auto;
}

.topicManage >>> .topic-create-drawer .el-dialog__footer {
  padding: 10px 20px 18px;
  border-top: 1px solid #ebeef5;
}

.topic-create-content {
  padding-bottom: 12px;
}

.upload-preview-wrapper {
  position: relative;
  display: inline-block;
  margin-top: 10px;
}

.upload-preview-wrapper:hover .upload-preview-delete {
  opacity: 1;
}

.upload-preview-delete {
  position: absolute;
  top: -8px;
  right: -8px;
  width: 20px;
  height: 20px;
  border-radius: 50%;
  background: rgba(0, 0, 0, 0.55);
  color: #fff;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  opacity: 0;
  transition: opacity 0.2s;
  font-size: 12px;
}

.create-upload-preview {
  display: block;
  width: 68px;
  height: 68px;
  border-radius: 4px;
  object-fit: cover;
  cursor: pointer;
}

.thumb-img {
  width: 42px;
  height: 42px;
  border-radius: 4px;
  object-fit: cover;
  vertical-align: middle;
}

.thumb-img-clickable {
  cursor: pointer;
}

.pagination-wrapper {
  display: flex;
  align-items: center;
  justify-content: space-between;
  flex-wrap: wrap;
  gap: 12px;
  padding: 14px 20px 0;
  box-sizing: border-box;
}

.bottom-action-wrapper {
  display: flex;
  gap: 10px;
}

.dialog-tip {
  margin-top: 6px;
  color: #666;
  font-size: 13px;
  line-height: 20px;
}

.pin-time-cell {
  padding: 2px 4px;
  font-size: 13px;
  color: #303133;
  line-height: 1.45;
}

.pin-time-line + .pin-time-line {
  margin-top: 2px;
}

.topic-pagination {
  margin-left: auto;
}

.image-preview-body {
  text-align: center;
  min-height: 200px;
}

.image-preview-img {
  max-width: 100%;
  max-height: 70vh;
  object-fit: contain;
  vertical-align: middle;
}

/* 上传提示文案（与新增页 newTopic.vue 保持一致） */
.supload-tips {
  margin-top: 6px;
  color: #8391a5;
  font-size: 12px;
  line-height: 1.5;
}
</style>



// WEBPACK FOOTER //
// topicManage.vue?a1d967da